import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SingleFilePickerField, SelectField } from '../../components'
import { Button } from '../../elements'

import validate from './validate'

class ProfileForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }
    state = {
        selectedClient: "",
        selectedSite: ""
    }

    changeSiteHandler = (values) => {
        this.setState({ selectedClient: values })
    }

    changeReaderHandler = (values) => {
        this.setState({ selectedSite: values })
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, sites, zones, agents } = this.props
        let clientIds = clients.map(client => client.clientId);
        let selectedSiteIds = sites.filter(site => site.clientId == this.state.selectedClient);
        let siteIds = selectedSiteIds.map(site => site.siteId)
        let selectedZoneIds = zones.filter(zone => zone.clientId == this.state.selectedClient &&
            zone.siteId == this.state.selectedSite);
        let zoneIds = selectedZoneIds.map(zone => zone.zoneId)
        let selectedAgentIds = agents.filter(agent => agent.clientId == this.state.selectedClient);
        let agentIds = selectedAgentIds.map(agent => agent.agentId)

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    // id="clientId"
                    options={clientIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    onChange={this.changeSiteHandler}
                    className="field"
                />
                <Field
                    name="cameraSn"
                    label="Camera SN"
                    // id="display_name"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    // id="clientId"
                    options={siteIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    onChange={this.changeReaderHandler}
                    className="field"
                />
                <Field
                    name="zoneId"
                    label="Zone Id"
                    // id="display_name"
                    options={zoneIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="agentId"
                    label="Agent Id"
                    // id="display_name"
                    options={agentIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="endpoint"
                    label="Endpoint"
                    // id="display_name"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />
                <Button loading={isSubmiting} htmlType="submit" type="primary">Create</Button>
            </form>
        )
    }
}

export default reduxForm({
    form: 'profile-form',
    validate,
})(ProfileForm)



// WEBPACK FOOTER //
// ./src/smart-components/profile-form/index.js